import React, { useState } from 'react'
import Reveal from './Reveal'
import SectionHead from './SectionHead'
import { useLightbox } from './Lightbox'
import { usePhotos } from '../i18n/hooks'
import { useI18n } from '../i18n/LanguageContext'

function Gallery() {
  const { t } = useI18n()
  const { photoList, galleryFilters } = usePhotos()
  const [filter, setFilter] = useState('all')
  const { open } = useLightbox()
  const visible = filter === 'all' ? photoList : photoList.filter((photo) => photo.area === filter)

  return (
    <section className="section section-alt" id="gallery" aria-labelledby="gallery-title">
      <div className="container">
        <SectionHead id="gallery-title" kicker={t.gallery.kicker} title={t.gallery.title} lead={t.gallery.lead} />
        <Reveal className="chips" role="group" aria-label={t.common.filterPhotosAria}>
          {galleryFilters.map((chip) => (
            <button
              key={chip.id}
              type="button"
              className={`chip${filter === chip.id ? ' is-active' : ''}`}
              aria-pressed={filter === chip.id}
              onClick={() => setFilter(chip.id)}
            >
              {chip.label}
            </button>
          ))}
        </Reveal>
        <ul className="masonry">
          {visible.map((photo, index) => (
            <li key={photo.id}>
              <button
                type="button"
                className="masonry-item"
                onClick={() => open(visible, index)}
                aria-label={`${t.common.enlargePrefix} ${photo.caption}`}
              >
                <img src={photo.src} alt={photo.alt} width={photo.width} height={photo.height} loading="lazy" />
                <span className="masonry-caption">{photo.caption}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Gallery
